<div class="parent">
  <div class="child">
    <span class="table-header">Index levels</span>
    <table class="custom-table-striped">
      <!--      FOR IBOXX INDICES       -->
      <tbody *ngIf="indexType === 'iboxx'">
        <tr>
          <td>TRI Today:</td>
          <td>{{(indexData.totalReturnIndex * 1).toFixed(4)}}</td>
        </tr>
        <tr>
          <td>TRI EOM:</td>
          <td>{{(indexData.totalReturnIndexPreviousEom * 1).toFixed(4)}}</td>
        </tr>
        <tr>
          <td>Market Value:</td>
          <td *ngIf="indexData.marketValue > 0">{{utilService.formatCurrency(indexData.marketValue) | number}}{{indexData.marketValue.toString().length > 7 ? ' M' : ' K'}}</td>
          <td *ngIf="indexData.marketValue === 0 || indexData.marketValue === null">0</td>
        </tr>
        <tr>
          <td>Cash Payment:</td>
          <td *ngIf="indexData.cashPayment > 0">{{utilService.formatCurrency(indexData.cashPayment) | number}} {{indexData.cashPayment.toString().length > 7 ? ' M' : ' K'}}</td>
          <td *ngIf="indexData.cashPayment === 0 || indexData.cashPayment === '0.0' || indexData.cashPayment === null">0</td>
        </tr>
        <tr>
          <td>Base Market Value:</td>
          <td *ngIf="indexData.baseMarketValue > 0">{{utilService.formatCurrency(indexData.baseMarketValue) | number}} {{indexData.baseMarketValue.toString().length > 7 ? ' M' : ' K'}}</td>
          <td *ngIf="indexData.baseMarketValue === 0 || indexData.baseMarketValue === null"></td>
        </tr>
        <tr>
          <td>Number of Constituents:</td>
          <td>{{indexData.numberOfInstruments}}</td>
        </tr>
        <tr *ngIf="indexData.investmentType.includes('Standardized_TRS')">
          <td>Coupon (%):</td>
          <td>{{(indexData.coupon * 1).toFixed(4)}}</td>
        </tr>
        <tr *ngIf="indexData.investmentType.includes('Standardized_TRS')">
          <td>Notional Amount:</td>
          <td>{{utilService.formatCurrency(indexData.nominalValue) | number}} {{indexData.nominalValue.toString().length > 7 ? ' M' : ' K'}}</td>
        </tr>
      </tbody>
      <!--   FOR CARBON INDICES   -->
      <tbody *ngIf="indexType === 'carbon'">
        <tr>
          <td>TRI Today:</td>
          <td>{{(indexData.totalReturn * 1).toFixed(4)}}</td>
        </tr>
        <tr>
          <td *ngIf="!indexData.id.includes('CCA') && !indexData.id.includes('EUA')">Weighted Carbon Price:</td>
          <td *ngIf="!indexData.id.includes('CCA') && !indexData.id.includes('EUA')">{{(indexData.weightedCarbonPrice * 1).toFixed(4)}}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="child">
    <div>
      <span class="table-header">Index Returns</span>
      <table class="custom-table-striped">
        <!--    FOR IBOXX INDICES    -->
        <tbody *ngIf="indexType === 'iboxx'">
          <tr>
            <td>Daily Return:</td>
            <td><span *ngIf="indexData.dailyReturn">{{(indexData.dailyReturn * 100).toFixed(4)}}</span></td>
          </tr>
          <tr>
            <td>Month to Date Return:</td>
            <td><span *ngIf="indexData.monthToDateReturn">{{(indexData.monthToDateReturn * 100).toFixed(4)}}</span></td>
          </tr>
          <tr>
            <td>Quarter to Date Return:</td>
            <td><span *ngIf="indexData.quarterToDateReturn">{{(indexData.quarterToDateReturn * 100).toFixed(4)}}</span></td>
          </tr>
          <tr>
            <td>Year to Date Return:</td>
            <td><span *ngIf="indexData.yearToDateReturn">{{(indexData.yearToDateReturn * 100).toFixed(4)}}</span></td>
          </tr>
          <tr *ngIf="indexData.investmentType.includes('Standardized_TRS')">
            <td>3YR TR (%):</td>
            <td *ngIf="indexData.totalReturnIndex3yr !== ''">{{(indexData.totalReturnIndex3yr * 100).toFixed(4)}}</td>
            <td *ngIf="indexData.totalReturnIndex3yr === ''">{{indexData.totalReturnIndex3yr}}</td>
          </tr>
          <tr *ngIf="indexData.investmentType.includes('Standardized_TRS')">
            <td>5YR TR (%):</td>
            <td *ngIf="indexData.totalReturnIndex5yr !== ''">{{(indexData.totalReturnIndex5yr * 100).toFixed(4)}}</td>
            <td *ngIf="indexData.totalReturnIndex5yr === ''">{{indexData.totalReturnIndex5yr}}</td>
          </tr>
        </tbody>
        <!--    FOR CARBON INDICES     -->
        <tbody *ngIf="indexType === 'carbon'">
          <tr>
            <td>Total Return %:</td>
            <td>{{(indexData.totalReturnPercentage * 100).toFixed(4)}}</td>
          </tr>
          <tr>
            <td>Price Return %:</td>
            <td>{{(indexData.priceReturnPercentage * 100).toFixed(4)}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="indexType === 'iboxx'">
      <span class="table-header">Index Analytics</span>
      <table class="custom-table-striped">
        <tbody>
          <tr>
            <td><span *ngIf="indexData.indexAnalyticsBond">Annual Yield:</span><span *ngIf="indexData.indexAnalyticsLoan">Current Yield:</span></td>
            <td *ngIf="indexData.indexAnalyticsBond">{{(indexData.indexAnalyticsBond.annualYield * 1).toFixed(4)}}</td>
            <td *ngIf="indexData.indexAnalyticsLoan">{{(indexData.indexAnalyticsLoan.currentYield * 1).toFixed(4)}}</td>
          </tr>
          <tr>
            <td><span *ngIf="indexData.indexAnalyticsBond">Duration:</span><span *ngIf="indexData.indexAnalyticsLoan">Modified Duration Maturity:</span></td>
            <td *ngIf="indexData.indexAnalyticsBond">{{(indexData.indexAnalyticsBond.duration * 1).toFixed(4)}}</td>
            <td *ngIf="indexData.indexAnalyticsLoan">{{(indexData.indexAnalyticsLoan.modifiedDurationMaturity * 1).toFixed(4)}}</td>
          </tr>
          <tr>
            <td *ngIf="indexData.indexAnalyticsBond">OAS (bps):</td><td *ngIf="indexData.indexAnalyticsLoan">Spread to Maturity:</td>
            <td *ngIf="indexData.indexAnalyticsBond">{{(indexData.indexAnalyticsBond.oas * 1).toFixed(4)}}</td>
            <td *ngIf="indexData.indexAnalyticsLoan">{{(indexData.indexAnalyticsLoan.spreadToMaturity * 1).toFixed(4)}}</td>
          </tr>
          <tr *ngIf="indexData.indexAnalyticsBond">
            <td>Asset Swap Spread:</td>
            <td>{{(indexData.indexAnalyticsBond.assetSwapSpreadOverLiborRfrCombined * 1).toFixed(4)}}</td>
          </tr>
        <tr *ngIf="indexData.indexAnalyticsBond && indexData.investmentType.includes('Standardized_TRS')">
          <td>Z-Spread (bps):</td>
          <td>{{(indexData.indexAnalyticsBond.zSpread * 1).toFixed(4)}}</td>
        </tr>
        <tr *ngIf="indexData.indexAnalyticsBond && indexData.investmentType.includes('Standardized_TRS')">
          <td>Annual Modified Duration:</td>
          <td>{{(indexData.indexAnalyticsBond.annualModifiedDuration * 1).toFixed(4)}}</td>
        </tr>
        <tr *ngIf="indexData.indexAnalyticsBond && (indexData.investmentType.includes('Standardized_TRS') || indexData.investmentType.includes('Futures'))">
          <td>DV01:</td>
          <td>{{(indexData.indexAnalyticsBond.dv01 * 1).toFixed(4)}}</td>
        </tr>
        </tbody>
      </table>
    </div>

  </div>
</div>
